import React from 'react'

import { FormFieldStatus, InputField } from '@gousto-internal/citrus-react'
// eslint-disable-next-line @library/dependency-radar/valid-imports
import { Field, FieldProps } from 'formik'

export const StreetInput = () => (
  <Field name="street">
    {({ field, meta }: FieldProps) => (
      <InputField
        id={field.name}
        data-testid="street"
        label="Street"
        status={meta.touched && meta.error ? FormFieldStatus.Error : undefined}
        validationMessage={meta.touched ? meta.error : undefined}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...field}
      />
    )}
  </Field>
)
